import { isNil } from 'lodash';

import { CommunicationWorkflowTargetOrderByName } from '@pwp-common';

import { TargetOrderByEditorOutput } from '../target-order-by-editor-output';
import { TargetOrderByFormType } from '../target-order-by-form-type';

export const targetOrderByToFormType = (targetOrderBy: TargetOrderByEditorOutput): TargetOrderByFormType => {
  if (
    isNil(targetOrderBy) ||
    isNil(targetOrderBy.type) ||
    !Object.values(CommunicationWorkflowTargetOrderByName).includes(targetOrderBy.type)
  ) {
    return {
      type: CommunicationWorkflowTargetOrderByName.explicit,
    };
  }

  return {
    type: targetOrderBy.type,
  };
};
